<template>
  <div>
    <v-dialog
      v-model="showModal"
      ref="alertModal"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      @hidden="hide"
    >
      <div class="text-center">
        <p class="f-lg mb-3">
          คุณจะได้รับแสตมป์สะสมเพิ่ม 1 ดวง <br />
          เมื่อซื้อผลิตภัณฑ์ในครั้งถัดไป
        </p>
        <hr />
      </div>

      <c-btn block variant="confirm-primary" @click="showModal = false"
        >{{ closeText || "ยืนยัน" }}
      </c-btn>
    </v-dialog>
    <v-dialog
      v-model="showProductModal"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
    >
      <div class="text-center">
        <p class="text-text f-xl mb-3">สินค้าที่ร่วมรายการ</p>
        <v-row class="align-items-center row-gap-lg">
          <template
            v-for="product of stampProduct"
            :key="'product-image-' + product.id"
          >
            <v-col cols="3"
              ><c-img class="w-100" :src="product.image_url"></c-img
            ></v-col>
            <v-col class="text-left" cols="9">{{ product.name }}</v-col>
          </template>
        </v-row>

        <hr />
      </div>

      <!-- <div class="border-top p-2 text-center btn-confirm-popup"> -->
      <c-btn
        block
        variant="confirm-primary"
        @click="showProductModal = false"
        >{{ closeText || "ยืนยัน" }}</c-btn
      >
      <!-- </div> -->
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      required: false,
      type: String
    },
    closeText: {
      required: false
    },
    stampCondition: {
      required: false
    },
    stampProduct: {
      required: false
    }
  },
  data() {
    return {
      showModal: false,
      showProductModal: false
    };
  },
  computed: {
    productItems() {
      if (this.stampProduct.length > 1) return "สินค้าที่ร่วมรายการ";
      if (this.stampProduct.length == 0) return "";
      if (this.stampProduct.length == 1)
        return this.stampProduct.map(el => el.name).join(", ");
    },
    unit() {
      return this.stampCondition.mission_redeem_condition == 2
        ? "บาท"
        : "ครั้ง";
    }
  },
  methods: {
    show() {
      this.showModal = true;
      this.$emit("show");
    },

    hide() {
      this.showModal = false;
      this.$emit("hide");
    },
    showProduct() {
      this.showProductModal = true;
    },
    hideProductModal() {
      this.showProductModal = false;
    }
  }
};
</script>

<style rel="scss" scoped>
.modal-header {
  border: 0 !important;
  padding: 0;
}
.text-text {
  margin-bottom: 0;

  font-weight: 600;
}
.modal-body {
  margin: auto;
  text-align: center;
}
.class-icon-black {
  width: 70px;
}
svg[data-icon="check-circle"] {
  color: var(--primary-color);
}
</style>
